import { useEffect, useState, type ReactNode } from "react";

export function HandlerTypingReveal({
  name,
  delay = 1200,
  children,
}: {
  name: string;
  delay?: number;
  children: ReactNode;
}) {
  const [ready, setReady] = useState(delay === 0);
  useEffect(() => {
    if (delay === 0) return;
    const timer = setTimeout(() => setReady(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  if (ready) return children;
  return (
    <div
      className="handler-message-row"
      role="status"
      aria-label={`${name} is typing`}
    >
      <div className="handler-bubble">
        <span className="handler-typing-dots" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      </div>
    </div>
  );
}
